"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlterMode = exports.PrivacySellState = exports.PrivacyTrackingState = exports.AuthenticationState = exports.DeviceType = void 0;
// ====================================================
// Enums
// ====================================================
/** Valid device types */
var DeviceType;
(function (DeviceType) {
    DeviceType["APP_PHONE"] = "APP_PHONE";
    DeviceType["APP_TABLET"] = "APP_TABLET";
    DeviceType["CHAT_APP"] = "CHAT_APP";
    DeviceType["DESKTOP"] = "DESKTOP";
    DeviceType["MOBILE_PHONE"] = "MOBILE_PHONE";
    DeviceType["MOBILE_TABLET"] = "MOBILE_TABLET";
    DeviceType["VOICE_APP"] = "VOICE_APP";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
var AuthenticationState;
(function (AuthenticationState) {
    AuthenticationState["ANONYMOUS"] = "ANONYMOUS";
    AuthenticationState["AUTHENTICATED"] = "AUTHENTICATED";
    AuthenticationState["IDENTIFIED"] = "IDENTIFIED";
})(AuthenticationState = exports.AuthenticationState || (exports.AuthenticationState = {}));
/** Privacy tracking user preference. We can retrieve info on if the site allowstracking from Site Info and null can also be used to represent a selection or not */
var PrivacyTrackingState;
(function (PrivacyTrackingState) {
    PrivacyTrackingState["CAN_NOT_TRACK"] = "CAN_NOT_TRACK";
    PrivacyTrackingState["CAN_TRACK"] = "CAN_TRACK";
})(PrivacyTrackingState = exports.PrivacyTrackingState || (exports.PrivacyTrackingState = {}));
/** User preference for data sharing with third parties which users may update */
var PrivacySellState;
(function (PrivacySellState) {
    PrivacySellState["CAN_NOT_SELL"] = "CAN_NOT_SELL";
    PrivacySellState["CAN_SELL"] = "CAN_SELL";
})(PrivacySellState = exports.PrivacySellState || (exports.PrivacySellState = {}));
/** Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages. */
var AlterMode;
(function (AlterMode) {
    /** None of the ALTER experiments will be used when resolving localization messages. */
    AlterMode["NONE"] = "NONE";
    /** This is the default. Only released ALTER experiments will be used when resolving localization messages. */
    AlterMode["RELEASED"] = "RELEASED";
    /** Both released and draft ALTER experiments will be used when resolving localization messages. */
    AlterMode["PREVIEW"] = "PREVIEW";
    /** Localization messages will be replaced with their namespace and loc key. */
    AlterMode["DEBUG"] = "DEBUG";
})(AlterMode = exports.AlterMode || (exports.AlterMode = {}));
//# sourceMappingURL=bex-api-context.js.map